import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsTwoColumnPdfLayoutSvg = lazy(
  () => import('./svg-components/digital-forms-two-column-pdf-layout-svg')
);

const DigitalFormsTwoColumnPdfLayoutSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsTwoColumnPdfLayoutSvg {...rest} />
  </Suspense>
);

export default DigitalFormsTwoColumnPdfLayoutSvg;
